<div>
  <p-dialog appendTo="body" [(visible)]="visible" (onHide)="hide()" [modal]="true"
    [style]="{'width': '1260px', 'height': '755px'}" [resizable]="false">

    <p-header>
      <span>SNMP Interface Utilization</span>
    </p-header>

    <div>
      <p-tabView>
        <p-tabPanel header="Settings" headerStyleClass="data-tab" [selected]="true">
          <snmpif-settings [editor]="policyEditor" [visible]="visible"></snmpif-settings>
        </p-tabPanel>
        <p-tabPanel header="Devices" headerStyleClass="data-tab">
          <snmpif-devices [editor]="policyEditor" [visible]="visible" (applyTempChangesIfValid)="applyTempChangesIfValid()"></snmpif-devices>
        </p-tabPanel>
        <p-tabPanel header="Schedule" headerStyleClass="data-tab">
          <monitor-schedule [editor]="policyEditor" [visible]="visible"></monitor-schedule>
        </p-tabPanel>
        <p-tabPanel header="Events" headerStyleClass="data-tab">
          <monitor-events [editor]="policyEditor" [visible]="visible"></monitor-events>
        </p-tabPanel>
        <p-tabPanel header="History" headerStyleClass="data-tab">
          <monitor-history [editor]="policyEditor" [visible]="visible" [schedule]="schedule"></monitor-history>
        </p-tabPanel>
      </p-tabView>

    </div>

    <p-footer>
      <button type="button" pButton icon="fa fa-check" [disabled]="!isSaveEnabled()" (click)="onSaveClicked()" label="Save"></button>
      <button type="button" pButton icon="fa fa-close" (click)="onCancelClicked()" label="Cancel"></button>
    </p-footer>

  </p-dialog>

  <p-dialog [(visible)]="showInvalidTempChangesDialog" appendTo="body">
    <p-header>
      <span>Invalid Changes</span>
    </p-header>
    <p>
      Invalid changes have been made in the following tabs and cannot be saved.
    </p>
    <ul>
      @for (tabName of tabsWithErrors; track tabName) {
        <li>{{tabName}}</li>
      }
    </ul>
    <p-footer>
      <button type="button" pButton (click)="onCancelSave()" label="Close"></button>
    </p-footer>
  </p-dialog>

</div>